import { type ChangeEvent, type MouseEvent } from 'react';

import Button from '../../../juristec-ui/core/Button';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';

import { compactString } from '../../../juristec-ui/utils/functions/formatString';
import { verifyEmail } from '../../../juristec-ui/utils/validators/inputTextValidators';
import type { ResetPasswordProps } from '../types';

import {
  FormFieldSet,
  FormField,
} from '../styled';

const ResetPassword = ({
  emailState, t, handleResetPasswordLink,
}: ResetPasswordProps) => {
  const [email, setEmail] = emailState;

  const emailHandle = (val: string) => {
    const msg = verifyEmail(val, true);
    setEmail({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const emailEvent = (e: ChangeEvent<HTMLInputElement>) => {
    emailHandle(compactString(e.target.value));
  };

  const handleSendLink = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (email.error) emailHandle(email.value);
    else handleResetPasswordLink();
  };

  return (
    <FormFieldSet>
      <h2>{t('resetTitle')}</h2>
      <FormField>
        <InputTextLine
          label={t('emailLabel')}
          type="email"
          value={email.value}
          errorMessage={email.errorMsg}
          error={email.errorMsg.length > 0}
          notTransparent={false}
          onChange={emailEvent}
          setValue={() => {}}
          autoComplete="off"
          autoFocus
        />
      </FormField>
      <FormField style={{ margin: '20px 0 0 0' }}>
        <Button
          type="submit"
          onClick={handleSendLink}
          textTransform="none"
          color="primary"
          size="large"
          style={{ width: '100%', margin: '0' }}
        >
          {t('Enviar link')}
        </Button>
      </FormField>
    </FormFieldSet>
  );
};

export default ResetPassword;
